import { Container } from 'pixi.js';
import type { CollectionEventImageLayoutInstance } from './collectionEventPredefinedStyles';
import { collectionEventPredefinedStyles } from './collectionEventPredefinedStyles';
import type { CollectionEventVisualConfig } from '../types';
import { VisualConfigType } from '../types';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class CollectionEventImageView extends Container {
  private readonly layout: CollectionEventImageLayoutInstance;

  constructor(visualStyle: CollectionEventVisualConfig) {
    super();

    if (visualStyle.configType === VisualConfigType.Custom) {
      throw new Error('Custom visuals are not supported yet');
    }

    this.layout = collectionEventPredefinedStyles[visualStyle.visualType].image();
    this.layout.root.props({
      parent: this,
    });

    void playLayoutAnimation(this.layout, 'idle', true);
  }
}
